module.exports = new __parcel__URL__("link-icon.10f40788.svg").toString();